import { Components, Theme } from "@mui/material";

declare module "@mui/material/Paper" {
  interface PaperPropsVariantOverrides {
    flat: true;
    AbsenceGroupsAccordion: true;
  }
}

const borderRadiusDefault = {
  borderRadius: "1rem",
  borderTopLeftRadius: "1rem",
  borderTopRightRadius: "1rem",
  borderBottomLeftRadius: "1rem",
  borderBottomRightRadius: "1rem",
};

export const MuiAccordion: Components<Theme>["MuiAccordion"] = {
  styleOverrides: {
    root: {
      ...borderRadiusDefault,

      "&:first-of-type": {
        ...borderRadiusDefault,
      },

      "&:last-of-type": {
        ...borderRadiusDefault,
      },

      "&:before": {
        display: "none",
      },
    },
  },
  variants: [
    {
      props: { variant: "flat" },
      style: ({ theme }) => ({
        ".MuiAccordionSummary-content": {
          display: "block",
          order: 1,
        },

        expandIconWrapper: {
          order: 0,
        },

        "&.MuiAccordion-root": {
          borderTop: `1px solid ${theme.palette.grey[300]}`,
          borderRadius: 0,
          margin: 0,
          boxShadow: "none",

          paddingTop: "0.5rem",

          "&:first-of-type": {
            border: "none",
            marginTop: 0,
            paddingTop: 0,
          },
        },

        ".MuiAccordionSummary-root": {
          padding: 0,
        },

        ".MuiAccordionDetails-root": {
          padding: 0,
        },
      }),
    },
    {
      props: { variant: "nestedListAccordion" },
      style: () => ({
        "&.MuiAccordion-root": {
          marginBottom: "1rem",
        },

        ".MuiAccordionSummary-root": {
          padding: "0.875rem 2rem",
        },

        ".MuiAccordionDetails-root": {
          padding: "2rem",
        },
      }),
    },
    {
      props: { variant: "AbsenceGroupsAccordion" },
      style: ({ theme }) => {
        const {
          palette: { grey },
        } = theme;

        return {
          "&.MuiAccordion-root": {
            marginBottom: "1rem",
          },

          ".MuiAccordionSummary-root": {
            background: grey[100],
            borderRadius: "1rem 1rem 0 0",
            padding: "0 2rem",

            "&:not(.Mui-expanded)": {
              borderRadius: "1rem",
            },
          },

          ".MuiAccordionSummary-content": {
            margin: "20px 0",
          },

          ".MuiAccordionDetails-root": {
            padding: "1rem",
          },
        };
      },
    },
  ],
};
